// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.styles_formContainer__ky4YB {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
}

.styles_button__xmPV0 {
  position: relative;
  text-align: right;
  background-color: #fafafa !important;
}

.styles_buttonStyle__RpsPU {
  background-color: inherit !important;
}

.styles_price__6kx2k {
  font-size: 10px;
}

.styles_input__S3iiT {
  max-width: 98%;
}

.styles_button__xmPV0:hover {
  cursor: pointer;
}

.styles_srtWrapper__KinHg {
  width: 100% !important;
}

.styles_srtInputStyle__sfioE {
  width: 0px !important;
}

.styles_button__xmPV0::after {
  position: absolute;
  left: 5px;
  top: 4px;
  content: "❬";
  transform: rotate(90deg);
  margin-top: 2px;
  color: rgba(0, 0, 0, 0.54);
}

.styles_button__xmPV0.styles_expanded__VFfKM::after {
  content: "❭";
}

.styles_inputStyle__RnpVQ {
  width: 48%;
  margin-left: 2%;
}

.styles_inputStyleFull__ZFhpW {
  width: 98%;
  margin-left: 2%;
}

.styles_inputWrapper__M2P4B {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #eeeeee;
  width: 100% !important;
  height: 44px;
}

.styles_inputStyleFullWrapper__eKvpE {
  width: 100%;
  height: auto;
  aspect-ratio: 8;
}

.styles_switchContainer__nvyde {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 48%;
  height: auto;
  margin-left: 2%;
  margin-top: 8px;
  margin-bottom: 8px;
}

.styles_switchTitle__4\\+TAc {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #707070;
}

.styles_switchDescription__LNagh {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
  color: #484848;
}

.styles_chooseButton__OTG85 {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */
  color: #d8000d;
}

.styles_seenBy__jVf0S {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
  color: #646464;
}

.styles_change__EuOyT {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */
  text-align: right;
  color: #d8000d;
  margin: 0 12px;
}

.styles_setting__8sdmM {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
  color: #d8000d;
  margin-bottom: 14px;
}

.styles_helpFooter__rJ2\\+D {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */
  text-align: right;
  color: #d8000d;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid #e9e9e9;
  padding-top: 11px;
}

.styles_searchContainer__UeQvb {
  position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  top: 90%;
  /* Elevation */
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  padding-bottom: 5px;
  padding-left: 9px;
  padding-right: 9px;
  z-index: 1000;
}

.styles_dark__\\+3a2X {
  background-color: #080808 !important;
}

.styles_white__BKxx9 {
  background-color: #fff;
}

.styles_playlistContainer__HxDyc {
  position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  top: 90%;
  /* Elevation */
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  padding-bottom: 5px;
  padding-left: 9px;
  padding-right: 9px;
  z-index: 1000;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  /* identical to box height, or 167% */
  color: #535353;
}

.styles_viewContainer__cj95t {
  position: absolute;
  width: 356px;
  height: auto;
  right: 100%;
  top: -100px;
  /* Elevation */
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  padding: 10px;
  z-index: 1000;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  /* identical to box height, or 167% */
  color: #535353;
}

.styles_playlistText__RPWom {
  margin-right: 11px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */
  text-align: right;
  color: #d8000d;
  cursor: pointer;
}

.styles_writeTag__jSW28 {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  /* Elevation */
  margin-bottom: 5px;
}

.styles_writeTag__jSW28 > div:nth-child(1) {
  width: calc(100% - 56px);
  margin: 0 5px;
}

.styles_addTag__b\\+z7d {
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #d8000d;
  border: 1px solid #d8000d;
  width: 20%;
  margin-right: 2%;
  border-radius: 8px;
  height: 44px;
  margin-top: 5px;
  cursor: pointer;
}

.styles_addTag__b\\+z7d span {
  width: auto;
  margin: 0 auto;
}

.styles_singleTag__kJPfM {
  /* Gray / gray-5 */
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 0px 5px;
  margin: 2px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #262626;
  white-space: nowrap;
}

.styles_srtTitle__Gg5bA {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */
  color: #535353;
  width: 100%;
}

.styles_lds_ring__lZ-rG {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  margin-bottom: 10px;
  margin-right: 20px;
}

.styles_lds_ring__lZ-rG div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  margin: 8px;
  border: 1px solid #d8000d;
  border-radius: 50%;
  animation: styles_lds_ring__lZ-rG 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #d8000d transparent transparent transparent;
}

.styles_lds_ring__lZ-rG div:nth-child(1) {
  animation-delay: -0.45s;
}

.styles_lds_ring__lZ-rG div:nth-child(2) {
  animation-delay: -0.3s;
}

.styles_lds_ring__lZ-rG div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes styles_lds_ring__lZ-rG {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.styles_chooseText__29h3C {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 35px;
  color: #969696;
}

.styles_tagBoxStyle__k2KVQ {
  max-height: 200px;
  overflow-y: auto;
  scrollbar-color: #e3e3e3 transparent;
  scrollbar-width: 5px;
  color: #ccc;
}

.styles_tagBoxStyle__k2KVQ::-webkit-scrollbar {
  background: transparent;
  width: 5px;
}

.styles_tagBoxStyle__k2KVQ::-webkit-scrollbar-thumb {
  background-color: #e3e3e3;
  border-radius: 100px;
  height: 5px;
}

@media only screen and (max-width: 800px) {
  .styles_inputStyle__RnpVQ {
    width: 98%;
    margin-left: 2%;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/UploadVideoForm/styles.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAEF;;AACA;EACE,kBAAA;EACA,iBAAA;EAEA,oCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,0BAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,UAAA;EACA,eAAA;AACF;;AAEA;EACE,UAAA;EACA,eAAA;AACF;;AAEA;EAEE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EAEA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADF;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EAEA,cAAA;AAJF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,cAAA;AAJF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAJF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,iBAAA;EAEA,cAAA;EACA,cAAA;AANF;;AASA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AANF;;AASA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,iBAAA;EAEA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;AARF;;AAWA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EAEA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,wHAAA;EAEA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;AAVF;;AAcA;EACE,oCAAA;AAXF;;AAcA;EACE,sBAAA;AAXF;;AAeA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EAEA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,wHAAA;EAEA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EAEA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,cAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EAEA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,wHAAA;EAEA,kBAAA;EACA,aAAA;EAIA,aAAA;EAEA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,cAAA;AAxBF;;AA2BA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,iBAAA;EAEA,cAAA;EACA,eAAA;AA1BF;;AA6BA;EACE,sBAAA;EAEA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EAGA,cAAA;EAIA,kBAAA;AAhCF;;AAqCA;EACE,wBAAA;EACA,aAAA;AAlCF;;AAqCA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,UAAA;EACA,gBAAA;EAGA,kBAAA;EAEA,YAAA;EACA,eAAA;EACA,eAAA;AArCF;;AAwCA;EACE,WAAA;EACA,cAAA;AArCF;;AAwCA;EAEE,kBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAvCF;;AA0CA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,cAAA;EACA,WAAA;AAxCF;;AA2CA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAxCF;;AA2CA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,4EAAA;EACA,yDAAA;AAxCF;;AA2CA;EACE,uBAAA;AAxCF;;AA2CA;EACE,sBAAA;AAxCF;;AA2CA;EACE,uBAAA;AAxCF;;AA2CA;EACE;IACE,uBAAA;EAxCF;EA2CA;IACE,yBAAA;EAzCF;AACF;AA4CA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1CF;;AA6CA;EACE,iBAAA;EACA,gBAAA;EACA,oCAAA;EACA,oBAAA;EACA,WAAA;AA1CF;;AA6CA;EAEE,uBAAA;EACA,UAAA;AA3CF;;AA8CA;EACE,yBAAA;EACA,oBAAA;EACA,WAAA;AA3CF;;AAgDA;EAEE;IACE,UAAA;IACA,eAAA;EA9CF;AACF","sourcesContent":[".formContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  width: 100%;\n  height: auto;\n}\n\n.button {\n  position: relative;\n  text-align: right;\n\n  background-color: #fafafa !important;\n}\n\n.buttonStyle {\n  background-color: inherit !important;\n}\n\n.price {\n  font-size: 10px;\n}\n\n.input {\n  max-width: 98%;\n}\n\n.button:hover {\n  cursor: pointer;\n}\n\n.srtWrapper {\n  width: 100% !important;\n}\n\n.srtInputStyle {\n  width: 0px !important;\n}\n\n.button::after {\n  position: absolute;\n  left: 5px;\n  top: 4px;\n  content: '\\276C';\n  transform: rotate(90deg);\n  margin-top: 2px;\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.button.expanded::after {\n  content: '\\276D';\n}\n\n.inputStyle {\n  width: 48%;\n  margin-left: 2%;\n}\n\n.inputStyleFull {\n  width: 98%;\n  margin-left: 2%;\n}\n\n.inputWrapper {\n  // width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  // background-color: #fafafa;\n  border-radius: 8px;\n  border: 1px solid #eeeeee;\n  width: 100% !important;\n  height: 44px;\n}\n\n.inputStyleFullWrapper {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 8;\n}\n\n.switchContainer {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 48%;\n  height: auto;\n  margin-left: 2%;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.switchTitle {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #707070;\n  // margin-bottom: 13px;\n}\n\n.switchDescription {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n\n  text-align: right;\n\n  color: #484848;\n}\n\n.chooseButton {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  /* identical to box height, or 150% */\n  color: #d8000d;\n}\n\n.seenBy {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  text-align: right;\n  color: #646464;\n}\n\n.change {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  /* identical to box height, or 150% */\n\n  text-align: right;\n\n  color: #d8000d;\n  margin: 0 12px;\n}\n\n.setting {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  text-align: right;\n  color: #d8000d;\n  margin-bottom: 14px;\n}\n\n.helpFooter {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  /* identical to box height, or 150% */\n\n  text-align: right;\n\n  color: #d8000d;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  border-top: 1px solid #e9e9e9;\n  padding-top: 11px;\n}\n\n.searchContainer {\n  position: absolute;\n  width: 100%;\n  height: auto;\n  left: 0;\n  top: 90%;\n  // background: #FFFFFF;\n  /* Elevation */\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),\n    0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);\n  border-radius: 2px;\n  padding-bottom: 5px;\n  padding-left: 9px;\n  padding-right: 9px;\n  z-index: 1000;\n  // background-color: inherit;\n}\n\n.dark {\n  background-color: #080808 !important;\n}\n\n.white {\n  background-color: #fff;\n  ;\n}\n\n.playlistContainer {\n  position: absolute;\n  width: 100%;\n  height: auto;\n  left: 0;\n  top: 90%;\n  // background: #FFFFFF;\n  /* Elevation */\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),\n    0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);\n  border-radius: 2px;\n  padding-bottom: 5px;\n  padding-left: 9px;\n  padding-right: 9px;\n  z-index: 1000;\n  // border-bottom: 1px solid #E9E9E9;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  /* identical to box height, or 167% */\n\n  color: #535353;\n}\n\n.viewContainer {\n  position: absolute;\n  width: 356px;\n  height: auto;\n  right: 100%;\n  // top: -200px; -------- use later\n  top: -100px;\n  // background: #FFFFFF;\n  /* Elevation */\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),\n    0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);\n  border-radius: 2px;\n  padding: 10px;\n  // padding-bottom: 5px;\n  // padding-left: 9px;\n  // padding-right: 9px;\n  z-index: 1000;\n  // border-bottom: 1px solid #E9E9E9;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  /* identical to box height, or 167% */\n\n  color: #535353;\n}\n\n.playlistText {\n  margin-right: 11px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  /* identical to box height, or 150% */\n\n  text-align: right;\n\n  color: #d8000d;\n  cursor: pointer;\n}\n\n.writeTag {\n  box-sizing: border-box;\n\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  // background-color: #ffffff;\n  // background: #FFFFFF;\n  /* Elevation */\n\n  // box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);\n  // border-radius: 2px;\n  margin-bottom: 5px;\n  // padding-left: 9px;\n  // padding-right: 9px;\n}\n\n.writeTag>div:nth-child(1) {\n  width: calc(100% - 56px);\n  margin: 0 5px;\n}\n\n.addTag {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 19px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: #d8000d;\n  border: 1px solid #d8000d;\n  width: 20%;\n  margin-right: 2%;\n  // height: auto;\n  // aspect-ratio: 2;\n  border-radius: 8px;\n  // background-color: #ffffff;\n  height: 44px;\n  margin-top: 5px;\n  cursor: pointer;\n}\n\n.addTag span {\n  width: auto;\n  margin: 0 auto;\n}\n\n.singleTag {\n  // background: #DFDFDF;\n  /* Gray / gray-5 */\n\n  border: 1px solid #d9d9d9;\n  border-radius: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  padding: 0px 5px;\n  margin: 2px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: #262626;\n  white-space: nowrap;\n}\n\n.srtTitle {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  /* identical to box height, or 143% */\n\n  color: #535353;\n  width: 100%;\n}\n\n.lds_ring {\n  display: inline-block;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  margin-bottom: 10px;\n  margin-right: 20px;\n}\n\n.lds_ring div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin: 8px;\n  border: 1px solid #d8000d;\n  border-radius: 50%;\n  animation: lds_ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #d8000d transparent transparent transparent;\n}\n\n.lds_ring div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.lds_ring div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.lds_ring div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n@keyframes lds_ring {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.chooseText {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 35px;\n  color: #969696;\n}\n\n.tagBoxStyle {\n  max-height: 200px;\n  overflow-y: auto;\n  scrollbar-color: #e3e3e3 transparent;\n  scrollbar-width: 5px;\n  color: #ccc;\n}\n\n.tagBoxStyle::-webkit-scrollbar {\n  // display: none !important;\n  background: transparent;\n  width: 5px;\n}\n\n.tagBoxStyle::-webkit-scrollbar-thumb {\n  background-color: #e3e3e3;\n  border-radius: 100px;\n  height: 5px;\n}\n\n\n\n@media only screen and (max-width: 800px) {\n\n  .inputStyle {\n    width: 98%;\n    margin-left: 2%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `styles_formContainer__ky4YB`,
	"button": `styles_button__xmPV0`,
	"buttonStyle": `styles_buttonStyle__RpsPU`,
	"price": `styles_price__6kx2k`,
	"input": `styles_input__S3iiT`,
	"srtWrapper": `styles_srtWrapper__KinHg`,
	"srtInputStyle": `styles_srtInputStyle__sfioE`,
	"expanded": `styles_expanded__VFfKM`,
	"inputStyle": `styles_inputStyle__RnpVQ`,
	"inputStyleFull": `styles_inputStyleFull__ZFhpW`,
	"inputWrapper": `styles_inputWrapper__M2P4B`,
	"inputStyleFullWrapper": `styles_inputStyleFullWrapper__eKvpE`,
	"switchContainer": `styles_switchContainer__nvyde`,
	"switchTitle": `styles_switchTitle__4+TAc`,
	"switchDescription": `styles_switchDescription__LNagh`,
	"chooseButton": `styles_chooseButton__OTG85`,
	"seenBy": `styles_seenBy__jVf0S`,
	"change": `styles_change__EuOyT`,
	"setting": `styles_setting__8sdmM`,
	"helpFooter": `styles_helpFooter__rJ2+D`,
	"searchContainer": `styles_searchContainer__UeQvb`,
	"dark": `styles_dark__+3a2X`,
	"white": `styles_white__BKxx9`,
	"playlistContainer": `styles_playlistContainer__HxDyc`,
	"viewContainer": `styles_viewContainer__cj95t`,
	"playlistText": `styles_playlistText__RPWom`,
	"writeTag": `styles_writeTag__jSW28`,
	"addTag": `styles_addTag__b+z7d`,
	"singleTag": `styles_singleTag__kJPfM`,
	"srtTitle": `styles_srtTitle__Gg5bA`,
	"lds_ring": `styles_lds_ring__lZ-rG`,
	"chooseText": `styles_chooseText__29h3C`,
	"tagBoxStyle": `styles_tagBoxStyle__k2KVQ`
};
export default ___CSS_LOADER_EXPORT___;
